import { render, staticRenderFns } from "./SelfResolve.vue?vue&type=template&id=2b6364d2&"
import script from "./SelfResolve.vue?vue&type=script&lang=js&"
export * from "./SelfResolve.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b6364d2')) {
      api.createRecord('2b6364d2', component.options)
    } else {
      api.reload('2b6364d2', component.options)
    }
    module.hot.accept("./SelfResolve.vue?vue&type=template&id=2b6364d2&", function () {
      api.rerender('2b6364d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Alerts/Sections/SelfResolve.vue"
export default component.exports